<template>
  <ControlCommonLayout header="controlHeader" footer="controlFooter">
    <b-overlay :show="overlayShow" rounded="sm">
      <div class="container">
        <div class="main-color text-light row mt-3">
          <div class="col p-2">
            <a id="orderList" class="ml-1 list-type" @click="goFocusSpecList()">棚割・注力商品設定</a>
            <a id="orderList" class="ml-1 list-type active-list">設定状況確認</a>
          </div>
        </div>

        <form method="post" action="#" class="form-horizontal">

          <div class="form-group row">
            <div class="col-sm-3 row">
              <div class="col-sm-12 px-0">
                <label for="area-date" class="control-label col-sm-12">エリア</label>
                <div class="col-sm-12 pr-0">
                  <v-select id="area-date" v-model="searchAreaName" label="label" :options="areaData" :reduce="options => options.value" :close-on-select="false" :deselectFromDropdown="true" multiple :loading="areaData.length <= 0"></v-select>
                </div>
              </div>
            </div>
            <div class="col-sm-3 row">
              <div class="col-sm-12 px-0">
                <label for="unit-date" class="control-label col-sm-12">ユニット</label>
                <div class="col-sm-12 pr-0">
                  <v-select id="unit-date" v-model="searchUnitName" label="label" :options="unitData" :reduce="options => options.value" :close-on-select="false" :deselectFromDropdown="true" multiple :loading="unitData.length <= 0"></v-select>
                </div>
              </div>
            </div>
            <div class="col-sm-3 row">
              <div class="col-sm-12 px-0">
                <label for="facility-date" class="control-label col-sm-12">施設</label>
                <div class="col-sm-12 pr-0">
                  <v-select id="facility-date" v-model="searchFacilityCode" label="label" :options="facilityData" :reduce="options => options.value" :close-on-select="false" :deselectFromDropdown="true" multiple :loading="facilityData.length <= 0"></v-select>
                </div>
              </div>
            </div>
            <div class="col-sm-3 row">
              <div class="col-sm-7 px-0">
                <label for="facility-date" class="control-label col-sm-12">期</label>
                <div class="col-sm-12 pr-0">
                  <v-select id="facility-date" v-model="searchPeriod" label="label" :options="periodData" :reduce="options => options.value" :close-on-select="false" :deselectFromDropdown="true" multiple :loading="periodData.length <= 0"></v-select>
                </div>
              </div>
              <div class="col-sm-5 text-right pr-0">
                <b-button variant="primary" style="margin-top: 30px;" @click="getPriceCountData()">適用</b-button>
              </div>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-sm-7 row">
            </div>
            <div class="col-sm-5 row">
              <div class="col-sm-7 text-right px-0">
                現在の表示内容: {{mode}}
              </div>
              <div class="col-sm-5 text-right pr-0">
                <b-button variant="outline-secondary" @click="changeMode()">棚割設定/注力設定</b-button>
              </div>
            </div>
          </div>

        </form>

        <div id="focus-box" class="row mt-3 base-color">
          <div class="accordion col p-0" role="tablist1">
            <b-card no-body>
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block v-b-toggle.accordion-1 id='focus-bar' class="light-blue text-left text-black" @click="changeIcon(1)"><b-icon id="icon-up_1" icon="chevron-up"></b-icon><b-icon id="icon-down_1" class="hide" icon="chevron-down"></b-icon>&nbsp;注力策定状況</b-button>
              </b-card-header>
              <!-- 注力策定状況BOX -->
              <b-collapse visible id="accordion-1" accordion="my-accordion1" role="tabpanel">
                <b-card-body>
                  <form method="post" action="#" class="form-horizontal">
                    <div class="form-group row">
                      <div class="col-sm-12">
                        <b-overlay :show="overlaySpecListShow" rounded="sm" class="col-sm-12">
                          <b-table-simple bordered class="small">
                            <thead role="rowgroup" class="table-bordered">
                              <tr role="row" class="align-middle">
                                <th rowspan="1" class="align-middle text-center th-head" style="width: 5%;"></th>
                                <th rowspan="1" class="align-middle text-center th-head" style="width: 12%;">メインテーブル</th>
                                <th rowspan="1" class="align-middle text-center th-head" style="width: 9%;">ゲストテーブル</th>
                              </tr>
                              <tr>
                                <th class="align-middle text-center th-head">計画</th>
                                <th class="align-middle text-center th-cell">{{toCommaSeparated(goalData['メインテーブル計画金額'])}}</th>
                                <th class="align-middle text-center th-cell">{{toCommaSeparated(goalData['ゲストテーブル計画金額'])}}</th>
                              </tr>
                              <tr>
                                <th class="align-middle text-center th-head">注力</th>
                                <th class="align-middle text-center th-cell">{{toCommaSeparated(goalData['メインテーブル注力金額'])}}</th>
                                <th class="align-middle text-center th-cell">{{toCommaSeparated(goalData['ゲストテーブル注力金額'])}}</th>
                              </tr>
                              <tr>
                                <th class="align-middle text-center th-head">計画差</th>
                                <th class="align-middle text-center th-cell" :style="goalData['メインテーブル差分金額'] < 0 ? 'color: red;' : ''">{{(goalData['メインテーブル差分金額'] > 0 ? '+' : '')}}{{toCommaSeparated(goalData['メインテーブル差分金額'])}}</th>
                                <th class="align-middle text-center th-cell" :style="goalData['ゲストテーブル差分金額'] < 0 ? 'color: red;' : ''">{{(goalData['ゲストテーブル差分金額'] > 0 ? '+' : '')}}{{toCommaSeparated(goalData['ゲストテーブル差分金額'])}}</th>
                              </tr>
                            </thead>
                          </b-table-simple>
                        </b-overlay>
                      </div>
                    </div>
                  </form>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>

        <!-- メインテーブルリスト -->
        <div class="row mt-3 base-color">
          <b-overlay :show="overlaySpecListShow" rounded="sm" class="col-sm-12">
            <div class="col-sm-12 row pt-3 pr-0">
              メインテーブル（設定スペック数）
            </div>
            <div class="col-sm-12 mt-3 padding0table" style="overflow: auto; white-space: pre-wrap; padding-left: 0;">
              <b-table-simple bordered class="small">
                <thead role="rowgroup" class="table-bordered">
                  <tr role="row" class="align-middle">
                    <th rowspan="1" class="align-middle text-center table-fixed" style="min-width: 130px;">価格帯</th>
                    <template v-for="(styleItem1, styleIndex1) in styleList">
                      <th :key="styleIndex1 + 'tbody'" rowspan="1" class="align-middle text-center" style="min-width: 60px;">{{toSlashBreak(styleItem1)}}</th>
                    </template>
                    <th rowspan="1" class="align-middle text-center" style="min-width: 130px;">合計</th>
                  </tr>
                </thead>
                <template v-for="(priceList1, priceindex1) in mainPriceList[mode]">
                  <b-tbody :key="priceindex1 + 'tbody'">
                    <b-tr :key="priceindex1 + 'mainPriceList'">
                      <b-td class="align-middle table-fixed" style="background-color: #fff;">{{mainPriceRangeList[priceindex1]}}</b-td>
                      <template v-for="(sItem1, sIndex1) in styleList">
                        <b-td :key="sIndex1 + 'mainPrice'" class="align-middle" :style="'background-color: rgba(255,' + (255 - 255 * priceList1[sItem1] / mainPriceListMax[mode]) + ',' + (255 - 255 * priceList1[sItem1] / mainPriceListMax[mode]) +', 1) !important;'" v-if="priceList1[sItem1] !== 0">{{toCommaSeparated(priceList1[sItem1])}}</b-td>
                        <b-td :key="sIndex1 + 'mainPrice'" class="align-middle" v-else></b-td>
                      </template>
                      <b-td class="align-middle">{{toCommaSeparated(priceRangeMainSumList[mode][priceindex1])}}</b-td>
                    </b-tr>
                  </b-tbody>
                </template>
                <thead role="rowgroup" class="table-bordered">
                  <tr role="row" class="align-middle">
                    <th rowspan="1" class="align-middle text-center table-fixed">合計</th>
                    <template v-for="(sumsItem1, sumsIndex1) in styleList">
                      <th :key="sumsIndex1 + 'mainPriceSum'" rowspan="1" class="align-middle th-cell">{{toCommaSeparated(styleMainSumList[mode][sumsItem1])}}</th>
                    </template>
                    <th rowspan="1" class="align-middle th-cell">{{toCommaSeparated(mainAllSum[mode])}}</th>
                  </tr>
                </thead>
              </b-table-simple>
            </div>
          </b-overlay>
        </div>

        <!-- ゲストテーブルリスト -->
        <div class="row mt-3 base-color">
          <b-overlay :show="overlaySpecListShow" rounded="sm" class="col-sm-12">
            <div class="col-sm-12 row pt-3 pr-0">
              ゲストテーブル（設定スペック数）
            </div>
            <div class="col-sm-12 mt-3 padding0table" style="overflow: auto; white-space: pre-wrap; padding-left: 0;">
              <b-table-simple bordered class="small">
                <thead role="rowgroup" class="table-bordered">
                  <tr role="row" class="align-middle">
                    <th rowspan="1" class="align-middle text-center table-fixed" style="min-width: 130px;">価格帯</th>
                    <template v-for="(styleItem2, styleIndex2) in styleList">
                      <th :key="styleIndex2 + 'tbody'" rowspan="1" class="align-middle text-center" style="min-width: 60px;">{{toSlashBreak(styleItem2)}}</th>
                    </template>
                    <th rowspan="1" class="align-middle text-center" style="min-width: 130px;">合計</th>
                  </tr>
                </thead>
                <template v-for="(priceList2, priceindex2) in guestPriceList[mode]">
                  <b-tbody :key="priceindex2 + 'tbody'">
                    <b-tr :key="priceindex2 + 'guestPriceList'">
                      <b-td class="align-middle table-fixed" style="background-color: #fff;">{{guestPriceRangeList[priceindex2]}}</b-td>
                      <template v-for="(sItem2, sIndex2) in styleList">
                        <b-td :key="sIndex2 + 'guestPrice'" class="align-middle" :style="'background-color: rgba(255,' + (255 - 255 * priceList2[sItem2] / guestPriceListMax[mode]) + ',' + (255 - 255 * priceList2[sItem2] / guestPriceListMax[mode]) +', 1) !important;'" v-if="priceList2[sItem2] !== 0">{{toCommaSeparated(priceList2[sItem2])}}</b-td>
                        <b-td :key="sIndex2 + 'guestPrice'" class="align-middle" v-else></b-td>
                      </template>
                      <b-td class="align-middle">{{toCommaSeparated(priceRangeGuestSumList[mode][priceindex2])}}</b-td>
                    </b-tr>
                  </b-tbody>
                </template>
                <thead role="rowgroup" class="table-bordered">
                  <tr role="row" class="align-middle">
                    <th rowspan="1" class="align-middle text-center table-fixed">合計</th>
                    <template v-for="(sumsItem1, sumsIndex1) in styleList">
                      <th :key="sumsIndex1 + 'guestPriceSum'" rowspan="1" class="align-middle th-cell">{{toCommaSeparated(styleGuestSumList[mode][sumsItem1])}}</th>
                    </template>
                    <th rowspan="1" class="align-middle th-cell">{{toCommaSeparated(guestAllSum[mode])}}</th>
                  </tr>
                </thead>
              </b-table-simple>
            </div>
          </b-overlay>
        </div>

      </div>
    </b-overlay>
    <CommonModal ref="commonModal" />
  </ControlCommonLayout>
</template>
<script>
import ControlCommonLayout from '@/layout/ControlCommonLayout'
import CommonModal from '@/components/CommonModal'
import SpecListModel from '@/models/SpecListModel'
import SpecCountModel from '@/models/SpecCountModel'
import AreaListModel from '@/models/AreaListModel'
import UnitListModel from '@/models/UnitListModel'
import FacilityListModel from '@/models/FacilityListModel'
import PeriodListModel from '@/models/PeriodListModel'
import StyleListModel from '@/models/StyleListModel'
import SearchFocusPlanModel from '@/models/SearchFocusPlanModel'
import Vue from 'vue'
import Paginate from 'vuejs-paginate'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
Vue.component('paginate', Paginate)
Vue.component('v-select', vSelect)

export default {
  name: 'InventorySpecList',
  components: { ControlCommonLayout, CommonModal, SpecListModel, SpecCountModel, AreaListModel, UnitListModel, FacilityListModel, PeriodListModel, StyleListModel, SearchFocusPlanModel },
  data () {
    return {
      overlayShow: false,
      overlaySpecListShow: false,
      userId: '',
      userRole: '',
      userRoleMode: '',
      userArea: '',
      userUnit: '',

      toroku: false,
      activeProjectList: [],
      projectData: [],
      projectDataBk: [],
      projectLength: 0,
      page: 1,
      pageMaxNum: 20,
      pageStart: 0,
      pageEnd: 0,
      SortDirection: {},

      modeList: ['棚割設定', '注力設定'],
      mode: '棚割設定',
      selectAllText: 'すべて',
      areaData: [],
      unitData: [],
      facilityData: [],
      periodData: [],
      searchAreaName: [],
      searchUnitName: [],
      searchFacilityCode: [],
      searchPeriod: [],
      searchDataSetFlg: false,

      styleList: [],
      mainPriceList: {},
      guestPriceList: {},
      mainPriceListMax: {},
      guestPriceListMax: {},
      mainPriceRangeList: [],
      guestPriceRangeList: [],
      priceRangeMainSumList: {},
      priceRangeGuestSumList: {},
      styleMainSumList: {},
      styleGuestSumList: {},
      mainAllSum: {},
      guestAllSum: {},

      goalData: {},
      tableNumber: ''
    }
  },
  methods: {
    setApiData: async function (isReload = false) {
      this.overlayShow = true
      console.log(this.$route.meta)
      console.log(this.$route.query)
      const dataKeepFlag = JSON.parse(sessionStorage.getItem('dataKeepFlag'))
      console.log(dataKeepFlag)
      if (this.$route.meta.userId && dataKeepFlag !== true) {
        console.log('設定状況確認画面の初期化処理')
        this.userId = this.$route.meta.userId
        localStorage.setItem('specGoalUserId', this.userId)

        // エリア、ユニット、施設、期、適用データの初期化
        localStorage.setItem('specGoalSearchAreaName', this.searchAreaName)
        localStorage.setItem('specGoalSearchUnitName', this.searchUnitName)
        localStorage.setItem('specGoalSearchFacilityCode', this.searchFacilityCode)
        localStorage.setItem('specGoalSearchPeriod', this.searchPeriod)
        localStorage.setItem('specGoalGoalData', this.goalData)
      } else {
        this.userId = localStorage.getItem('specGoalUserId')
        this.userRole = localStorage.getItem('specGoalUserRole')
        this.userArea = localStorage.getItem('specGoalUserArea')
        this.userUnit = localStorage.getItem('specGoalUserUnit')
      }
      console.log(this.userId)

      const result = await SpecListModel.getApi(this.$bvModal, null, () => {})
      for (const tantosha of result['tantosha']) {
        if (this.userId === tantosha['担当者コード']['value']) {
          this.userRole = tantosha['役割']['value']
          localStorage.setItem('specGoalUserRole', this.userRole)
          this.userArea = tantosha['所属エリア']['value']
          localStorage.setItem('specGoalUserArea', this.userArea)
          this.userUnit = tantosha['所属ユニット']['value']
          localStorage.setItem('specGoalUserUnit', this.userUnit)
          break
        }
      }
      console.log(this.userRole)
      console.log(this.userArea)
      console.log(this.userUnit)

      // ユーザーの役割に応じたモード変更
      this.setUserRoleMode()
      console.log(this.userRoleMode)

      // 選択肢の情報を取得
      await this.setSelectItems()
      // スタイル、価格帯の初期設定
      await this.setDataList()

      this.overlayShow = false
    },
    setUserRoleMode () {
      const roleMode = {
        'システム管理者': 3,
        '運用管理者': 3,
        '本部マネージャー': 3,
        'エリアマネージャー': 1,
        'ユニットリーダー': 1,
        'チームリーダー': 1,
        'メンバー': 1,
        'プランナー': 0,
        'SDP': 2
      }
      this.userRoleMode = (this.userRole in roleMode) ? roleMode[this.userRole] : 0
    },
    toSlashBreak (str) {
      if (str) {
        try {
          return str.replace('/', '/\n')
        } catch (err) {
          return ''
        }
      }
      return str
    },
    toCommaSeparated (str) {
      if (str) {
        try {
          return parseInt(str, 10).toLocaleString()
        } catch (err) {
          return ''
        }
      }
      return str
    },
    changeIcon (num) {
      document.getElementById('icon-up_' + num).classList.toggle('hide')
      document.getElementById('icon-down_' + num).classList.toggle('hide')
    },
    validate () {
      // 検索条件のチェックを追加する
      return true
    },
    getPriceCountData: async function (isPageBack = false) {
      // 前画面から戻った時でなければ画面入力値のチェックを行う
      if (!isPageBack) {
        if (!this.validate()) {
          return false
        }
      }
      this.overlaySpecListShow = true

      const getData = {
        'searchAreaName': this.searchAreaName,
        'areaName': this.getSelectListDict(this.getSearchSelect(this.searchAreaName, this.areaData)),
        'searchUnitName': this.searchUnitName,
        'unitName': this.getSelectListDict(this.getSearchSelect(this.searchUnitName, this.unitData)),
        'searchFacilityCode': this.searchFacilityCode,
        'facilityCode': this.getSelectListDict(this.getSearchSelect(this.searchFacilityCode, this.facilityData)),
        'searchPeriod': this.searchPeriod,
        'period': this.getSelectListDict(this.getSearchSelect(this.searchPeriod, this.periodData))
      }

      // 権限に応じた検索条件の追加
      if (this.userRoleMode === 1 || this.userRoleMode === 2) {
        getData['userArea'] = this.userArea
      }
      if (this.userRoleMode === 2) {
        getData['userUnit'] = this.userUnit
      }

      let goalsData = await SearchFocusPlanModel.getApi(this.$bvModal, getData, () => {})
      console.log(goalsData)
      if (!goalsData['goals'] || goalsData['status'] !== 'success') {
        console.log('注力策定情報検索失敗')
        this.$refs.commonModal.msgBoxOk('注力策定情報の検索に失敗いたしました。')
        this.overlaySpecListShow = false
        return false
      }

      // データセット
      this.goalData = goalsData['goals']
      this.tableNumber = goalsData['goals']['ゲストテーブル卓数']

      // エリア、ユニット、施設、期、適用、卓数データの保存
      localStorage.setItem('specGoalSearchAreaName', this.searchAreaName)
      localStorage.setItem('specGoalSearchUnitName', this.searchUnitName)
      localStorage.setItem('specGoalSearchFacilityCode', this.searchFacilityCode)
      localStorage.setItem('specGoalSearchPeriod', this.searchPeriod)
      localStorage.setItem('specGoalGoalData', JSON.stringify(this.goalData))
      localStorage.setItem('specGoalTableNumber', this.tableNumber)

      // メインゲストの値を設定
      await SpecCountModel.getApi(this.$bvModal, getData, (data) => {
        console.log(data)

        if (data['status'] === 'success') {
          for (let h = 0; h < this.modeList.length; h++) {
            this.mainPriceList[this.modeList[h]] = data['maincounts'][this.modeList[h]].slice()
            this.guestPriceList[this.modeList[h]] = data['guestcounts'][this.modeList[h]].slice()
            this.mainPriceListMax[this.modeList[h]] = data['mainmaxcount'][this.modeList[h]]
            this.guestPriceListMax[this.modeList[h]] = data['guestmaxcount'][this.modeList[h]]

            // 価格帯、スタイルごとの合計
            const max = 12
            // 合計値の初期化
            this.mainAllSum[this.modeList[h]] = 0
            this.guestAllSum[this.modeList[h]] = 0
            for (let i = 0; i < max; i++) {
              this.priceRangeMainSumList[this.modeList[h]][i] = 0
              this.priceRangeGuestSumList[this.modeList[h]][i] = 0
            }
            for (let j = 0; j < this.styleList.length; j++) {
              this.styleMainSumList[this.modeList[h]][this.styleList[j]] = 0
              this.styleGuestSumList[this.modeList[h]][this.styleList[j]] = 0
            }
            // 合計値算出
            for (let i = 0; i < max; i++) {
              for (let j = 0; j < this.styleList.length; j++) {
                if (this.styleList[j] in this.mainPriceList[this.modeList[h]][i]) {
                  // スタイルごとの合計
                  this.styleMainSumList[this.modeList[h]][this.styleList[j]] += this.mainPriceList[this.modeList[h]][i][this.styleList[j]]
                  // 価格帯ごとの合計
                  this.priceRangeMainSumList[this.modeList[h]][i] += this.mainPriceList[this.modeList[h]][i][this.styleList[j]]
                  // 全合計
                  this.mainAllSum[this.modeList[h]] += this.mainPriceList[this.modeList[h]][i][this.styleList[j]]
                } else {
                  this.mainPriceList[this.modeList[h]][i][this.styleList[j]] = 0
                }
                if (this.styleList[j] in this.guestPriceList[this.modeList[h]][i]) {
                  // スタイルごとの合計
                  this.styleGuestSumList[this.modeList[h]][this.styleList[j]] += this.guestPriceList[this.modeList[h]][i][this.styleList[j]]
                  // 価格帯ごとの合計
                  this.priceRangeGuestSumList[this.modeList[h]][i] += this.guestPriceList[this.modeList[h]][i][this.styleList[j]]
                  // 全合計
                  this.guestAllSum[this.modeList[h]] += this.guestPriceList[this.modeList[h]][i][this.styleList[j]]
                } else {
                  this.guestPriceList[this.modeList[h]][i][this.styleList[j]] = 0
                }
              }
            }
          }
        }
      }, () => {
      })

      // 検索条件を保存
      localStorage.setItem('searchSpecCount', JSON.stringify(getData))
      this.overlaySpecListShow = false
    },
    goFocusSpecList () {
      this.$router.push({
        name: 'FocusSpecList',
        query: {}
      })
    },

    setSelectItemsValidate (area = '', unit = '') {
      let areacheck = (area === '' || this.userArea === area)
      let unitcheck = (unit === '' || this.userUnit === unit)
      return (this.userRoleMode === 3 || (this.userRoleMode === 1 && areacheck) || (this.userRoleMode === 2 && areacheck && unitcheck))
    },
    setSelectItems: async function () {
      this.searchDataSetFlg = false

      // エリア、ユニット、施設、期、適用データの反映
      if (localStorage.getItem('specGoalSearchAreaName')) {
        try {
          this.searchAreaName = String(localStorage.getItem('specGoalSearchAreaName')).split(',').map(str => parseInt(str, 10))
        } catch (e) {
          this.searchAreaName = []
        }
      }
      if (localStorage.getItem('specGoalSearchUnitName')) {
        try {
          this.searchUnitName = String(localStorage.getItem('specGoalSearchUnitName')).split(',').map(str => parseInt(str, 10))
        } catch (e) {
          this.searchUnitName = []
        }
      }
      if (localStorage.getItem('specGoalSearchFacilityCode')) {
        try {
          this.searchFacilityCode = String(localStorage.getItem('specGoalSearchFacilityCode')).split(',').map(str => parseInt(str, 10))
        } catch (e) {
          this.searchFacilityCode = []
        }
      }
      if (localStorage.getItem('specGoalSearchPeriod')) {
        try {
          this.searchPeriod = String(localStorage.getItem('specGoalSearchPeriod')).split(',').map(str => parseInt(str, 10))
        } catch (e) {
          this.searchPeriod = []
        }
      }
      if (localStorage.getItem('specGoalGoalData')) {
        try {
          this.goalData = JSON.parse(localStorage.getItem('specGoalGoalData'))
        } catch (e) {
          this.goalData = {}
        }
      }

      // プルダウン内容設定
      let areas = (await AreaListModel.getApi(this.$bvModal))['areas']
      this.areaData = []
      if (!areas) {
        this.areaData.push({ 'label': '', 'value': '' })
        return
      }
      this.areaData.push({ 'label': this.selectAllText, 'value': 0, 'searchValue': '' })
      for (let i = 0; i < areas['records'].length; i++) {
        if (this.setSelectItemsValidate(areas['records'][i]['エリア名'].value)) {
          this.areaData.push({ 'label': areas['records'][i]['エリア名'].value, 'value': this.areaData.length, 'searchValue': areas['records'][i]['エリア名'].value })
        }
      }

      let units = (await UnitListModel.getApi(this.$bvModal))['units']
      if (this.searchAreaName.length === 0) {
        this.unitData = []
        if (!units) {
          this.unitData.push({ 'label': '', 'value': '' })
          return
        }
        this.unitData.push({ 'label': this.selectAllText, 'value': 0, 'searchValue': '' })
        for (let i = 0; i < units['records'].length; i++) {
          if (this.setSelectItemsValidate(units['records'][i]['所属エリア'].value, units['records'][i]['ユニット名'].value)) {
            this.unitData.push({ 'label': units['records'][i]['ユニット名'].value, 'value': this.unitData.length, 'searchValue': units['records'][i]['ユニット名'].value })
          }
        }
      } else {
        await this.setUnits()
      }

      let facilities = (await FacilityListModel.getApi(this.$bvModal))['facilities']
      if (this.searchAreaName.length === 0 && this.searchUnitName.length === 0) {
        this.facilityData = []
        if (!facilities) {
          this.facilityData.push({ 'label': '', 'value': '' })
          return
        }
        this.facilityData.push({ 'label': this.selectAllText, 'value': 0, 'searchValue': '' })
        for (let i = 0; i < facilities['records'].length; i++) {
          if (this.setSelectItemsValidate(facilities['records'][i]['担当エリア'].value, facilities['records'][i]['担当ユニット'].value)) {
            this.facilityData.push({ 'label': facilities['records'][i]['施設名'].value, 'value': this.facilityData.length, 'searchValue': facilities['records'][i]['施設コード'].value })
          }
        }
      } else {
        await this.setFacilities()
      }

      let period = (await PeriodListModel.getApi(this.$bvModal))['period']
      let nowperiod = (await PeriodListModel.getApi(this.$bvModal))['nowperiod']

      this.periodData = []
      if (!period) {
        this.periodData.push({ 'label': '', 'value': '' })
        return
      }
      this.periodData.push({ 'label': this.selectAllText, 'value': 0, 'searchValue': '' })
      for (let i = 0; i < period['records'].length; i++) {
        if (nowperiod['期'].value === period['records'][i]['期'].value && this.searchPeriod.length === 0 && this.goalData === {}) {
          this.searchPeriod.push(this.periodData.length)
        }
        this.periodData.push({ 'label': period['records'][i]['表示名'].value, 'value': this.periodData.length, 'searchValue': period['records'][i]['期'].value })
      }

      setTimeout(() => {
        this.searchDataSetFlg = true
      }, 500)
    },
    getSearchSelect (numList, dataList) {
      let res = []
      for (let i = 0; i < numList.length; i++) {
        res.push(dataList[numList[i]].searchValue)
      }
      return res
    },
    getSelectListDict (dataList) {
      let res = {}
      for (let i = 0; i < dataList.length; i++) {
        if (dataList[i] !== '') {
          res[dataList[i]] = dataList[i]
        }
      }
      return res
    },
    setUnits: async function () {
      if (this.searchDataSetFlg) {
        // 検索値初期化
        this.searchUnitName = []
      }

      // 選択肢絞込み
      let units = UnitListModel.getStore('units')
      this.unitData = []
      if (!units) {
        this.unitData.push({ 'label': '', 'value': '' })
        return
      }
      this.unitData.push({ 'label': this.selectAllText, 'value': 0, 'searchValue': '' })
      for (let i = 0; i < units['records'].length; i++) {
        let addflg = (this.searchAreaName.length === 0)
        // 権限上問題ないか確認
        if (this.setSelectItemsValidate(units['records'][i]['所属エリア'].value, units['records'][i]['ユニット名'].value)) {
          for (let j = 0; j < this.searchAreaName.length; j++) {
            if (this.areaData[this.searchAreaName[j]]) {
              if (this.areaData[this.searchAreaName[j]]['label'] === units['records'][i]['所属エリア'].value || this.areaData[this.searchAreaName[j]]['label'] === this.selectAllText) {
                addflg = true
                break
              }
            }
          }
          if (addflg) {
            this.unitData.push({ 'label': units['records'][i]['ユニット名'].value, 'value': this.unitData.length, 'searchValue': units['records'][i]['ユニット名'].value })
          }
        }
      }
      // 空ならダミーデータを入れる
      if (this.unitData.length === 0) {
        this.unitData.push({ 'label': '', 'value': '', 'searchValue': '' })
      }
    },
    setFacilities: async function () {
      if (this.searchDataSetFlg) {
        // 検索値初期化
        this.searchFacilityCode = []
      }

      // 選択肢絞込み
      let facilities = FacilityListModel.getStore('facilities')
      this.facilityData = []
      if (!facilities) {
        this.facilityData.push({ 'label': '', 'value': '' })
        return
      }
      this.facilityData.push({ 'label': this.selectAllText, 'value': 0, 'searchValue': '' })
      for (let i = 0; i < facilities['records'].length; i++) {
        let areaflg = (this.searchAreaName.length === 0)
        // 権限上問題ないか確認
        if (this.setSelectItemsValidate(facilities['records'][i]['担当エリア'].value, facilities['records'][i]['担当ユニット'].value)) {
          for (let j = 0; j < this.searchAreaName.length; j++) {
            if (this.areaData[this.searchAreaName[j]]) {
              if (this.areaData[this.searchAreaName[j]]['label'] === facilities['records'][i]['担当エリア'].value || this.areaData[this.searchAreaName[j]]['label'] === this.selectAllText) {
                areaflg = true
                break
              }
            }
          }
          let unitflg = (this.searchUnitName.length === 0)
          for (let j = 0; j < this.searchUnitName.length; j++) {
            if (this.unitData[this.searchUnitName[j]]) {
              if (this.unitData[this.searchUnitName[j]]['label'] === facilities['records'][i]['担当ユニット'].value || this.unitData[this.searchUnitName[j]]['label'] === this.selectAllText) {
                unitflg = true
                break
              }
            }
          }
          if (areaflg && unitflg) {
            this.facilityData.push({ 'label': facilities['records'][i]['施設名'].value, 'value': this.facilityData.length, 'searchValue': facilities['records'][i]['施設コード'].value })
          }
        }
      }
      // 空ならダミーデータを入れる
      if (this.facilityData.length === 0) {
        this.facilityData.push({ 'label': '', 'value': '', 'searchValue': '', 'hideValue': '' })
      }
    },

    setDataList: async function () {
      // スタイルの初期情報を取得
      this.styleList = []
      let style = (await StyleListModel.getApi(this.$bvModal))['style']
      let stylePriceList = {}
      if (!style) {
        return
      }
      for (let i = 0; i < style['records'].length; i++) {
        this.styleList.push(style['records'][i]['スタイル'].value)
        for (let h = 0; h < this.modeList.length; h++) {
          stylePriceList[style['records'][i]['スタイル'].value] = 0
        }
      }

      this.mainAllSum = {}
      this.guestAllSum = {}
      for (let h = 0; h < this.modeList.length; h++) {
        // スタイルごとの合計
        this.styleMainSumList[this.modeList[h]] = Object.assign({}, stylePriceList)
        this.styleGuestSumList[this.modeList[h]] = Object.assign({}, stylePriceList)

        // 価格帯の初期情報を取得
        this.mainPriceList[this.modeList[h]] = []
        this.guestPriceList[this.modeList[h]] = []
        this.priceRangeMainSumList[this.modeList[h]] = []
        this.priceRangeGuestSumList[this.modeList[h]] = []
        this.mainAllSum[this.modeList[h]] = 0
        this.guestAllSum[this.modeList[h]] = 0
      }

      this.mainPriceRangeList = []
      const max = 12
      for (let i = 0; i < max; i++) {
        const rate = 50000
        const from = '' + rate * i
        let to = '' + (rate * (i + 1) - 1)
        if (i === max - 1) {
          to = ''
        }
        // 価格帯
        this.mainPriceRangeList.push(this.toCommaSeparated(from) + '～' + this.toCommaSeparated(to))
        for (let h = 0; h < this.modeList.length; h++) {
          // 各セルの件数
          this.mainPriceList[this.modeList[h]].push(Object.assign({}, stylePriceList))
          // 価格帯ごとの合計
          this.priceRangeMainSumList[this.modeList[h]].push(0)
        }
      }
      this.guestPriceRangeList = []
      for (let i = 0; i < max; i++) {
        const rate = 5000
        const from = '' + rate * i
        let to = '' + (rate * (i + 1) - 1)
        if (i === max - 1) {
          to = ''
        }
        // 価格帯
        this.guestPriceRangeList.push(this.toCommaSeparated(from) + '～' + this.toCommaSeparated(to))
        for (let h = 0; h < this.modeList.length; h++) {
          // 各セルの件数
          this.guestPriceList[this.modeList[h]].push(Object.assign({}, stylePriceList))
          // 価格帯ごとの合計
          this.priceRangeGuestSumList[this.modeList[h]].push(0)
        }
      }
    },
    changeMode: async function () {
      if (this.mode === this.modeList[0]) {
        this.mode = this.modeList[1]
      } else {
        this.mode = this.modeList[0]
      }
    },
    setVSelect (select, newData, oldData) {
      if (newData.length > 1 && this.searchDataSetFlg) {
        for (let j = 0; j < newData.length; j++) {
          if (newData[j] === 0) {
            if (select === 'searchAreaName') {
              if (oldData.length === 1 && oldData[0] === 0) {
                this.searchAreaName.splice(j, 1)
              } else {
                this.searchAreaName = [0]
              }
            } else if (select === 'searchUnitName') {
              if (oldData.length === 1 && oldData[0] === 0) {
                this.searchUnitName.splice(j, 1)
              } else {
                this.searchUnitName = [0]
              }
            } else if (select === 'searchFacilityCode') {
              if (oldData.length === 1 && oldData[0] === 0) {
                this.searchFacilityCode.splice(j, 1)
              } else {
                this.searchFacilityCode = [0]
              }
            } else if (select === 'searchPeriod') {
              if (oldData.length === 1 && oldData[0] === 0) {
                this.searchPeriod.splice(j, 1)
              } else {
                this.searchPeriod = [0]
              }
            }
            break
          }
        }
      }
    }
  },
  computed: {
    getSearchAreaName () {
      return this.searchAreaName
    },
    getSearchUnitName () {
      return this.searchUnitName
    },
    getSearchFacilityCode () {
      return this.searchFacilityCode
    },
    getSearchPeriod () {
      return this.searchPeriod
    }
  },
  watch: {
    getSearchAreaName: function (newData, oldData) {
      this.setUnits()
      this.setFacilities()
      this.setVSelect('searchAreaName', newData, oldData)
    },
    getSearchUnitName: function (newData, oldData) {
      this.setFacilities()
      this.setVSelect('searchUnitName', newData, oldData)
    },
    getSearchFacilityCode: function (newData, oldData) {
      this.setVSelect('searchFacilityCode', newData, oldData)
    },
    getSearchPeriod: function (newData, oldData) {
      this.setVSelect('searchPeriod', newData, oldData)
    }
  },
  mounted () {
    document.title = '棚割・注力設定'
    if (process.env.APP_ENV !== 'production') {
      document.title = '【テスト環境】棚割・注力設定'
    }
    this.setApiData()
  },
  created () {
  },
  destroyed () {
  }
}
</script>
<style>
.active-list {
  background-color: #CACFEC;
  color: rgb(22, 28, 61);
}
.list-type {
  padding: 0.5rem;
  color: #fefefe;
}
.list-type:hover {
  color: #fefefe;
  cursor: pointer;
}
.active-list:hover {
  background-color: #CACFEC;
  color: rgb(22, 28, 61);
  cursor: default;
  text-decoration: none;
}
.th-head {
  background-color: #cacfec !important;
  border: 1px solid #dee2e6 !important;
  color: #000000;
  font-weight: normal;
}

.th-cell {
  background-color: #FFFFFF !important;
  border: 1px solid #eefdff !important;
  color: #000000;
  font-weight: normal;
}

.white-line {
  background-color: #fff;
}
.white-line:hover {
  background-color: #d9efff !important;
}
.gray-line {
  background-color: #eefdff;
}
.gray-line:hover {
  background-color: #d9efff !important;
}

.table-fixed {
  position: sticky;
  left:0px;
  z-index: 1;
}

.padding0table .table td, .padding0table .table th {
    padding: 0rem;
}

</style>



// WEBPACK FOOTER //
// src/pages/InventorySpecList.vue